module.exports = __webpack_public_path__ + "media/assets/images/blog/quite_quitting-a998cca789892ad7547014c3b30d778e.png";